import { useMemo, type FC } from "react";

import {
  TEXT_EYEBROW_DEFAULTS,
  TTextEyebrowProps,
} from "@/ui/components/typography/TextEyebrow/TextEyebrow.config";
import {
  TYPOGRAPHY_COLORS_CLASS_MAP,
} from "@/ui/components/typography/typography.config";
import { TextTitle } from "@/ui/components/typography/TextTitle";
import {
  getTextEyebrowChildElementTag,
} from "@/ui/components/typography/TextEyebrow/TextEyebrow.utils";
import {
  isTextEyebrowChildSubtitle,
  isTextEyebrowChildTitle,
} from "@/ui/components/typography/TextEyebrow/TextEyebrow.guards";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import { clsx } from "clsx";

export const TextEyebrow: FC<TTextEyebrowProps> = (
  {
    tag: Tag = TEXT_EYEBROW_DEFAULTS.tag,
    color = TEXT_EYEBROW_DEFAULTS.color,
    children,
    child,
    className,
    ...props
  },
) => {

  const childTag = useMemo(() => getTextEyebrowChildElementTag(Tag), [ Tag ]);
  const childElement = useMemo(() => {
    if (isTextEyebrowChildTitle(child)) {
      const { component: _component, ...titleProps } = child;

      return <TextTitle {...titleProps} tag={childTag} isResponsive={false} />;
    }

    if (isTextEyebrowChildSubtitle(child)) {
      const { component: _component, ...subtitleProps } = child;

      return <TextSubtitle {...subtitleProps} tag={childTag} isResponsive={false} />;
    }

    return null;
  }, [ child, childTag ]);

  return (
    <div data-component="TextEyebrow" className="flex flex-col">
      <Tag
        {...props}
        className={clsx(
          "text-sys-sm uppercase font-sys-default font-bold leading-sys-1",
          TYPOGRAPHY_COLORS_CLASS_MAP[color],
          className,
        )
        }
      >
        { children }
      </Tag>

      { childElement }
    </div>
  );
};

TextEyebrow.displayName = "TextEyebrow";
